(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cebe-editorial-chapter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cebe-editorial-chapter')) {
    customElements.define('cebe-editorial-chapter', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.motion !== 'true' || this.hasAttribute('data-revealed')) return;
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.setAttribute('data-revealed', '');
          this.observer.disconnect();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cebe-local-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let lastLocalFocus = null;
    document.addEventListener('focusin', (event) => {
      lastLocalFocus = event.target.closest('.cebe-local-nav') ? event.target : null;
    });
    document.addEventListener('focusout', (event) => {
      if (!event.relatedTarget && event.target.getClientRects().length) lastLocalFocus = null;
    });
    document.addEventListener('keydown', (event) => {
      const menu = event.target.closest('.cebe-local-nav__menu');
      if (!menu || !menu.open) return;
      if (event.key === 'Escape') {
        menu.open = false;
        menu.querySelector(':scope > summary').focus({ preventScroll: true });
        event.preventDefault();
        event.stopPropagation();
      } else if (event.key === 'Tab') {
        setTimeout(() => {
          if (!menu.contains(document.activeElement)) menu.open = false;
        }, 0);
      }
    });

    window.matchMedia('(min-width: 751px)').addEventListener('change', (event) => {
      document.querySelectorAll('.cebe-local-nav').forEach((nav) => {
        const menu = nav.querySelector('.cebe-local-nav__menu');
        if (!menu) return;
        const current = document.activeElement;
        const active = current === document.body && nav.contains(lastLocalFocus) ? lastLocalFocus : current;
        const menuFocused = menu.contains(active);
        const rowFocused = nav.querySelector('.cebe-local-nav__scroller').contains(active);
        menu.open = false;
        if (event.matches && menuFocused) {
          const link = Array.from(nav.querySelectorAll('.cebe-local-nav__link')).find(
            (item) => item.getAttribute('href') === active.getAttribute('href')
          );
          const target = link || nav.querySelector('.cebe-local-nav__title[href], .cebe-local-nav__link');
          target?.focus({ preventScroll: true });
        } else if (!event.matches && rowFocused) {
          menu.querySelector(':scope > summary').focus({ preventScroll: true });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
